import React from "react";

import "../Policy/policy.css";

const Terms = () => {
  return (
    <div className="main-policy">
      <div className="header-policy">
        <p>TERMS OF USE</p>
      </div>
      <div className="content-policy">
        <p>
          Please read these Terms of Use carefully as they apply to your use of
          Blaze Brand Limited's website ("Website"). By using the Website, you
          agree to be bound by these Terms of Use which form a legally binding
          agreement between you and BBL. If you do not want to be bound by these
          Terms of Use, do not continue to use this Website. Further, we may
          amend these Terms of Use at any time. Your continued use of the
          Website is considered to be acceptance of the amended Terms of Use.
        </p>
      </div>
      <div className="policies">
        <div className="p1">
          <h3>DISCLAIMER</h3>
          <p>
            Blaze Brand Limited makes the information published on this website
            as accurate as possible. However, the information on this website is
            provided on an “as is” basis without any express or implied
            warranty. There is no guarantee given as to the accuracy or currency
            of any individual item on this website.
          </p>
          <h3>BBL'S COPYRIGHT</h3>
          <p>
            The material on this Website, including all information such as
            text, graphics, images, photographs and sound, is protected by
            copyright pursuant to the Copyright Act 1968 (Cth), as amended from
            time to time and the laws of other countries. You must not alter,
            reproduce, store in retrieval system or transmit the material on
            this Website or any part thereof, unless authorised by BBL in
            writing or permitted by the Copyright Act 1968 (Cth).
          </p>
          <h3>TRADE MARKS</h3>
          <p>
            All trademarks that are included on this Website are the property of
            their respective owners and are protected by relevant laws in
            Nigeria and other countries. You must not use any of these trade
            marks (including the reproduction, modification, distribution,
            repudiation, display or communication of these trade marks) except
            by saving or printing out a copy of this Website for personal
            non-commercial use, unless expressly authorised by BBL or the owner
            of the relevant trade mark in writing.
          </p>
          <h3>LINKS FROM THIS WEBSITE</h3>
          <p>
            The external linked websites within the Website are not within the
            control of BBL and does not take responsibility for the content in,
            or currency of, any externally linked sites. A link on the Website
            neither implies endorsement by BBL of the linked website, nor a
            relationship with the organisation linked.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Terms;
